module.exports = __webpack_public_path__ + "img/q3-2.0d7699a4.png";